/** @format */

class SetNetConfig {
  constructor(config) {
    // this.loginURL = "https://conf.scspc.gov.cn:8222/yjs-gateway"; // 登录时环境+特殊环境
    /* this.baseURL = process.env.BASE_URL; // 变量控制——接口地址
		this.gateWay = process.env.GATE_WAY; // 变量控制——接口网关
		this.webURL = process.env.WEB_URL;
		this.previewbaseUrl = process.env.previewbaseUrl_URL;// 预览地址1
		this.previewbaseUrlTwo = process.env.previewbaseUrlTwo_URL;// 预览地址2
		this.BiUrl = process.env.Bi_URL;// 预览地址2 */
    this.timeout = 10000000000;

    /* 本地调试 */
    this.gateWay = " ";
    // this.baseURL = 'http://192.168.37.221:8668/performance'
    this.baseURL = process.env.VUE_APP_REMOTE_API;

    //this.baseURL = 'http://192.168.44.169:8802',
    //this.baseURL = 'http://192.168.44.112:8802'; // 变量控制——接口地址
    // this.baseURL = 'http://192.168.45.236:8802'
    // this.webURL = 'ws://192.168.0.39:8075/we	bsocket/';
    // this.baseURL = 'http://192.168.43.254:8802';   // 冯帅
    // this.baseURL = 'http://192.168.3.222:8802';   // 刘海
    // this.baseURL = 'http://192.168.249.51:8802';   // 邵晨阳
    //this.baseURL = 'http://172.20.10.5:8802';   // 皓天
    // this.baseURL = 'http://172.20.10.2:8802';   // 博一
    // websocket
  }
}

export default SetNetConfig;
